import React from "react";
import styles from "../SubjectSinglePage.module.css";
import type { GistReaderMode } from "../model/types";

type GistModeSwitchProps = {
  subjectTitle?: string;
  readerMode: GistReaderMode;
  onBackToSubject: () => void;
  onChangeMode: (mode: GistReaderMode) => void;
};

const READER_MODES: GistReaderMode[] = ["read", "tools", "advanced"];

function getModeLabel(mode: GistReaderMode): string {
  if (mode === "read") return "Read";
  if (mode === "tools") return "Tools";
  return "Advanced";
}

export function GistModeSwitch({
  subjectTitle,
  readerMode,
  onBackToSubject,
  onChangeMode,
}: GistModeSwitchProps) {
  return (
    <div className={styles.gistModeStickyBar}>
      <div className={styles.gistModeStickyInner}>
        <div className={styles.gistModeStickyLeft}>
          <span className={styles.gistModeStickySubject}>{subjectTitle}</span>
          <button
            type="button"
            className={styles.gistModeStickyBack}
            onClick={onBackToSubject}
            aria-label="Back to subject overview"
          >
            ← Back to subject
          </button>
        </div>
        <div className={styles.gistModeRow} aria-label="Gist reader mode">
          {READER_MODES.map((mode) => (
            <button
              type="button"
              key={mode}
              className={`${styles.gistModeButton} ${readerMode === mode ? styles.gistModeButtonActive : ""}`}
              onClick={() => onChangeMode(mode)}
            >
              {getModeLabel(mode)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
